/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="md" variant="full" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const parentsProfileTableData = (students = []) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "student Name", align: "left" },
    { name: "Class", align: "left" },
    { name: "Board", align: "left" },
    { name: "Subject", align: "left" },
    { name: "Gender", align: "left" },
    { name: "Date of Birth", align: "left" },
    { name: "Phone", align: "left" },
    { name: "Email", align: "left" },
  ],

  rows:
    console.log("Students data:", students) || (students && students.length > 0)
      ? students.map((student, index) => ({
          sno: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {index + 1}
            </ArgonTypography>
          ),
          "student Name": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.name || "N/A"}
            </ArgonTypography>
          ),
          Class: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.class?.name || "N/A"}
            </ArgonTypography>
          ),
          Board: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.board?.name || "N/A"}
            </ArgonTypography>
          ),
          Subject: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.subjects?.map((s) => s.name).join(", ") || "N/A"}
            </ArgonTypography>
          ),
          Gender: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.gender || "N/A"}
            </ArgonTypography>
          ),
          "Date of Birth": (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {student?.dob ? new Date(student.dob).toLocaleDateString() : "N/A"}
            </ArgonTypography>
          ),
          Phone: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.parentId?.phone || "N/A"}
            </ArgonTypography>
          ),
          Email: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {student?.parentId?.email || "N/A"}
            </ArgonTypography>
          ),
        }))
      : [
          {
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            "student Name": (
              <ArgonTypography variant="caption" color="error" fontWeight="medium">
                No students found
              </ArgonTypography>
            ),
            Class: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            Board: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            Subject: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            Gender: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            "Date of Birth": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            Phone: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            Email: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
          },
        ],
});

// {
//   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
//   function: <Function job="Manager" org="Organization" />,
//   status: (
//     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//   ),
//   employed: (
//     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//       23/04/18
//     </ArgonTypography>
//   ),
//   action: (
//     <ArgonTypography
//       component="a"
//       href="#"
//       variant="caption"
//       color="secondary"
//       fontWeight="medium"
//     >
//       Edit
//     </ArgonTypography>
//   ),
// },

// {
//   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
//   function: <Function job="Programator" org="Developer" />,
//   status: (
//     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//   ),
//   employed: (
//     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//       11/01/19
//     </ArgonTypography>
//   ),
//   action: (
//     <ArgonTypography
//       component="a"
//       href="#"
//       variant="caption"
//       color="secondary"
//       fontWeight="medium"
//     >
//       Edit
//     </ArgonTypography>
//   ),
// },
// {
//   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
//   function: <Function job="Executive" org="Projects" />,
//   status: (
//     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//   ),
//   employed: (
//     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//       19/09/17
//     </ArgonTypography>
//   ),
//   action: (
//     <ArgonTypography
//       component="a"
//       href="#"
//       variant="caption"
//       color="secondary"
//       fontWeight="medium"
//     >
//       Edit
//     </ArgonTypography>
//   ),
// },
// {
//   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
//   function: <Function job="Programator" org="Developer" />,
//   status: (
//     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//   ),
//   employed: (
//     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//       24/12/08
//     </ArgonTypography>
//   ),
//   action: (
//     <ArgonTypography
//       component="a"
//       href="#"
//       variant="caption"
//       color="secondary"
//       fontWeight="medium"
//     >
//       Edit
//     </ArgonTypography>
//   ),
// },
// {
//   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
//   function: <Function job="Manager" org="Executive" />,
//   status: (
//     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//   ),
//   employed: (
//     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//       04/10/21
//     </ArgonTypography>
//   ),
//   action: (
//     <ArgonTypography
//       component="a"
//       href="#"
//       variant="caption"
//       color="secondary"
//       fontWeight="medium"
//     >
//       Edit
//     </ArgonTypography>
//   ),
// },
// {
//   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
//   function: <Function job="Programtor" org="Developer" />,
//   status: (
//     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//   ),
//   employed: (
//     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//       14/09/20
//     </ArgonTypography>
//   ),
//   action: (
//     <ArgonTypography
//       component="a"
//       href="#"
//       variant="caption"
//       color="secondary"
//       fontWeight="medium"
//     >
//       Edit
//     </ArgonTypography>
//   ),
// },
// ],
// });

export default parentsProfileTableData;
